import * as THREE from 'three'
import type { ScreenshotConfig, ViewerConfig, Vec3 } from '../types'

const BASE_WIDTH = 130
const MAX_WIDTH = 240
const MAX_DISTANCE_BOOST = 1.0

export const screenshot: ScreenshotConfig = {
  getCameraPosition(width: number, config: ViewerConfig): Vec3 {
    const base: Vec3 = [...config.cameraPosition]
    if (width < BASE_WIDTH) return base

    const widthExcess = Math.min(width - BASE_WIDTH, MAX_WIDTH - BASE_WIDTH)
    const distanceScale =
      1 + (widthExcess / (MAX_WIDTH - BASE_WIDTH)) * MAX_DISTANCE_BOOST

    const target = new THREE.Vector3(...config.target)
    const direction = new THREE.Vector3(...base).sub(target)
    const adjusted = target.clone().add(direction.multiplyScalar(distanceScale))
    return [adjusted.x, adjusted.y, adjusted.z]
  },
}
